import React from 'react';
import "./Companies.css";

const Companies = () => {
  return (
    <section className="c-wrapper">
        <div className="padding innerWidth c-container">
        <img src="./equinix.png" alt="a" />
        <img src="./prologis.png" alt="b" />
        <img src="./realty.png" alt="c" />
        <img src="./tower.png" alt="d" />

        </div>
    </section>
  )
};

export default Companies
